module.exports = __webpack_public_path__ + "fonts/Inter-500-latin-ext34.1ad231a.woff2";